/* angular:styles/component:css;ea485542613dfeaff000763f1287dc1101af22eae10946a8e3684bf958c5a6f9;/app/src/app/shared/animations/image-browser.component.ts */
.overlay {
  background: #ffffff;
  position: relative;
  opacity: 0.5;
}
.add-image {
  width: 27px;
  height: 23px;
  margin-top: 8px;
  margin-bottom: 3px;
  align-self: center;
}
.drop-an-image-text {
  font-family: Lato;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #333333;
  text-align: center;
}
.browse {
  padding-top: 5px;
  display: flex;
  justify-content: center;
}
.browse-button {
  width: 72px;
  height: 28px;
  border-radius: 19px;
  background-color: #333333;
  font-family: Lato;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}
.example-container {
  display: flex;
  flex-wrap: wrap;
}
.card-frame {
  width: 137px;
  height: 116px;
  border-radius: 8px;
  border: 1px solid #cccccc;
  margin-right: 8px;
  margin-bottom: 8px;
}
.card-frame-notext {
  width: 137px;
  height: 87px;
  border-radius: 8px;
  border: 1px solid #cccccc;
  margin-right: 8px;
  margin-bottom: 8px;
}
.card-image-container {
  height: 87px;
  width: 100%;
  position: relative;
}
.card-image {
  object-fit: cover;
  height: inherit;
  width: inherit;
  border-radius: 8px 8px 0px 0px;
}
.card-image-notext {
  object-fit: cover;
  height: inherit;
  width: inherit;
  border-radius: 8px;
}
.card-text-box {
  display: flex;
  justify-content: center;
  margin-top: 3px;
  background-color: white;
}
.card-text {
  max-width: 90%;
  font-family: Lato;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #333333;
  text-align: center;
  outline: none;
  padding-left: 2px;
  max-width: 100%;
}
.no-text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.absolute-placement-top {
  position: absolute;
  top: 4px;
  left: 4px;
  max-width: 90%;
  display: flex;
}
.absolute-placement-bottom {
  position: absolute;
  bottom: -12px;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 90%;
}
.center-content {
  display: flex;
  justify-content: center;
}
.dark-text-outline-small {
  background-color: #333333;
  width: 18px;
  height: 18px;
  border-radius: 9px;
  padding: 0px 8px;
  display: flex;
  justify-content: center;
}
.dark-text-outline {
  background-color: #333333;
  width: fit-content;
  height: 18px;
  border-radius: 9px;
  padding: 0px 8px;
  display: flex;
  justify-content: center;
}
.dark-text {
  font-family: Lato;
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: center;
  color: #f2eee7;
}
.blur-background-static {
  height: inherit;
  width: inherit;
}
.blur-background {
  -webkit-filter: blur(2px);
  -moz-filter: blur(2px);
  -o-filter: blur(2px);
  -ms-filter: blur(2px);
  filter: blur(2px);
}
.purple-circle {
  width: 30px;
  height: 30px;
  border-radius: 32px;
  background-color: #61566e;
  display: flex;
  justify-content: center;
  cursor: pointer;
}
.hide-image {
  width: 18px;
  height: 13px;
  object-fit: cover;
  align-self: center;
}
.tiny-spacing {
  padding-left: 8px;
}
.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow:
    0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14),
    0 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.cdk-drag-placeholder {
  opacity: 0.2;
}
.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
/*# sourceMappingURL=image-browser.component.css.map */
